import { createFileRoute } from "@tanstack/react-router";
import bgImage from "@/assets/nn-bg.svg";
import contentImage from "@/assets/nn-page-content.svg";
import type { JSX } from "react";
import { Logo } from "@/components/Logo";
import { COLORS } from "@/constants";
import { LandingLogo } from "@/components/LandingLogo";

const LogoReplacement = (): JSX.Element => (
  <div className="bg-white w-69 h-10 my-31 mx-51 absolute p-2">
    <Logo fill={COLORS.logoRed} width="270" />
  </div>
);

const CornerLogo = (): JSX.Element => (
  <div className="absolute my-160 mx-130">
    <LandingLogo fill={COLORS.bgGreen} width="140" />
  </div>
);

const Background = (): JSX.Element => (
  <div className="fixed inset-0 -z-10">
    <img
      src={bgImage}
      alt="Background"
      className="absolute inset-0 w-full h-full object-cover"
    />
  </div>
);

const Content = (): JSX.Element => (
  <div className="my-25 mx-25">
    <img src={contentImage} alt="content" />
  </div>
);

const LearnMore = (): JSX.Element => {
  return (
    <>
      <CornerLogo />
      <LogoReplacement />
      <Background />
      <Content />
    </>
  );
};

export const Route = createFileRoute("/learn-more")({
  component: LearnMore,
});
